export const activitiesHero = {
  title: 'Our Activities & Events',
  subtitle: 'From digital bootcamps to community gatherings, our activities bring youth together to learn, grow, and make a difference in Pulau Pinang.',
  imageUrl: 'https://readdy.ai/api/search-image?query=Community%20event%20in%20Malaysian%20neighborhood%20with%20diverse%20youth%20participating%2C%20colorful%20banners%2C%20energetic%20atmosphere%2C%20tropical%20sunlight%2C%20joyful%20gathering%2C%20warm%20community%20spirit&width=1600&height=800&seq=hero-activities&orientation=landscape',
};

export const activitiesList = [
  {
    id: 'bootcamp-2026',
    title: 'Youth Digital Bootcamp 2026',
    date: '15 July 2026',
    time: '9:00 AM - 5:00 PM',
    location: 'Butterworth Community Hall',
    category: 'Workshop',
    description: 'A 3-day intensive bootcamp covering web development, digital marketing, and basic cybersecurity for youth aged 16-25. Participants will build real projects, learn from industry mentors, and earn a certificate of completion.',
    highlights: ['Hands-on coding sessions', 'Industry mentor guidance', 'Certificate of completion', 'Free lunch provided'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Youth%20digital%20bootcamp%20workshop%20in%20community%20hall%2C%20students%20working%20on%20laptops%2C%20energetic%20learning%20environment%2C%20modern%20classroom%20setup%2C%20Malaysian%20youth%2C%20bright%20natural%20lighting%2C%20diverse%20participants%2C%20professional%20atmosphere&width=800&height=600&seq=activity-bootcamp-2026&orientation=landscape',
    status: 'upcoming',
  },
  {
    id: 'cleanup-2026',
    title: 'Community Clean-Up & Tech Day',
    date: '2 August 2026',
    time: '8:00 AM - 2:00 PM',
    location: 'Kampung Gajah Area, Butterworth',
    category: 'Community',
    description: 'A combined environmental initiative and tech consultation event. Volunteers will help clean up local neighborhoods in the morning, followed by free tech consultation booths for residents in the afternoon. Bring your family and friends!',
    highlights: ['Environmental clean-up', 'Free tech consultations', 'Community bonding', 'Refreshments provided'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Community%20cleanup%20event%20in%20Malaysian%20village%2C%20volunteers%20picking%20up%20litter%2C%20tech%20booth%20set%20up%20nearby%2C%20sunny%20day%2C%20community%20spirit%2C%20green%20surroundings%2C%20families%20participating&width=800&height=600&seq=activity-cleanup-2026&orientation=landscape',
    status: 'upcoming',
  },
  {
    id: 'mentorship-open-2026',
    title: 'Mentorship Open Day',
    date: '20 September 2026',
    time: '10:00 AM - 4:00 PM',
    location: 'INSAN PERWIRA Center, Butterworth',
    category: 'Networking',
    description: 'Meet our mentors, learn about our mentorship program structure, and sign up for the next mentorship cycle. Open to all youth aged 16-30 in Pulau Pinang. Light refreshments will be served.',
    highlights: ['Meet the mentors', 'Program overview', 'On-site registration', 'Networking session'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20day%20networking%20event%20with%20mentors%20and%20youth%20in%20modern%20center%2C%20name%20tags%2C%20coffee%20and%20snacks%2C%20friendly%20conversations%2C%20warm%20indoor%20lighting%2C%20professional%20yet%20casual%2C%20Malaysian%20participants&width=800&height=600&seq=activity-mentorship-open-2026&orientation=landscape',
    status: 'upcoming',
  },
  {
    id: 'coding-weekend-2025',
    title: 'Weekend Coding Camp',
    date: '12 April 2025',
    time: '9:00 AM - 4:00 PM',
    location: 'Butterworth Digital Hub',
    category: 'Workshop',
    description: 'A weekend-long coding camp where 45 youth learned HTML, CSS, and JavaScript fundamentals. Participants built their first personal website by the end of the camp.',
    highlights: ['45 participants', '100% completion rate', 'Personal website projects', 'Guest speakers from tech industry'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Weekend%20coding%20camp%20with%20youth%20learning%20web%20development%2C%20laptops%20on%20desks%2C%20instructor%20helping%20students%2C%20bright%20modern%20classroom%2C%20focused%20young%20Malaysians%2C%20collaborative%20atmosphere&width=800&height=600&seq=activity-coding-weekend-2025&orientation=landscape',
    status: 'past',
  },
  {
    id: 'ramadan-outreach-2025',
    title: 'Ramadan Community Outreach',
    date: '22 March 2025',
    time: '4:00 PM - 8:00 PM',
    location: 'Multiple Locations, Butterworth',
    category: 'Community',
    description: 'Distributed food packages and educational materials to 200+ families across Butterworth during Ramadan. Our youth volunteers led the entire operation from planning to distribution.',
    highlights: ['200+ families served', '50 youth volunteers', 'Educational materials distributed', 'Cross-community collaboration'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Ramadan%20community%20food%20distribution%20in%20Malaysian%20neighborhood%2C%20volunteers%20handing%20out%20packages%2C%20warm%20evening%20light%2C%20smiling%20families%2C%20community%20spirit%2C%20colorful%20traditional%20atmosphere&width=800&height=600&seq=activity-ramadan-outreach-2025&orientation=landscape',
    status: 'past',
  },
  {
    id: 'career-fair-2025',
    title: 'Youth Career Discovery Fair',
    date: '8 February 2025',
    time: '10:00 AM - 5:00 PM',
    location: 'Butterworth Community Hall',
    category: 'Networking',
    description: 'Connected 300+ youth with 20 local employers and 5 educational institutions. Included resume workshops, mock interviews, and career guidance sessions.',
    highlights: ['300+ attendees', '20 employer booths', 'Resume workshops', 'Mock interview practice'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Career%20fair%20in%20community%20hall%20with%20booths%20and%20young%20Malaysians%20talking%20to%20employers%2C%20professional%20atmosphere%2C%20bright%20indoor%20lighting%2C%20networking%2C%20informational%20posters%2C%20diverse%20participants&width=800&height=600&seq=activity-career-fair-2025&orientation=landscape',
    status: 'past',
  },
];

export const activityCategories = ['All', 'Workshop', 'Community', 'Networking'];